<template>
	<div>		
		<h1 class="view-title">
			CONFIGURAÇÕES - LISTAGEM
		</h1>
		<div class="inner-content shadowed">
			<div class="inner-content-title">
				Lista
				<button class="button-edit admin-create-btn" @click="create()">
					<i class="fa fa-plus"></i> NOVO
				</button>
				<div class="admin-filter-wrapper">
					<input class="admin-filter-input" type="text" placeholder="Buscar" v-model="search" @keydown.enter.prevent="load(true)" />
					<i class="fa fa-fw fa-search"></i>
				</div>
			</div>
			<div class="row">
				<div class="col-xs">
					<Table 
					:loading="loading"
					:headers="headers" 
					:modifiers="modifiers" 
					:ordering="[]" 
					:list="list" 
					:page="page"
					:per_page="per_page" 
					:total="total" 
					@next="() => { page++; load(); }" 
					@prev="() => { page--; load(); }"
					v-slot="{item}">
						<button v-if="item.name.toLowerCase() == 'whatsapp'" class="button-edit" @click="getQRCode(item)" title="Gerar QR Code de conexão">
							<i class="fa fa-fw fa-qrcode"></i> GERAR QRCODE
						</button>
						<button v-if="item.name.toLowerCase() == 'whatsapp'" class="button-edit" @click="verifyStatusLogin(item)" title="Verificar status da conexão">
							<i class="fa fa-fw fa-sync"></i> VERIFICAR STATUS
						</button>
						<button class="button-edit" @click="edit(item)" title="Alterar registro">
							<i class="fa fa-fw fa-edit"></i> ALTERAR
						</button>
                        <button class="button-remove" @click="remove(item.id)" title="Excluir registro">
							<i class="fa fa-fw fa-trash"></i> EXCLUIR 
						</button>
					</Table>
				</div>
			</div>
		</div>
		<AdminSettingForm v-if="showForm" :current="current" />
		<AdminSettingQRCode v-if="showQRCode" :current="current" />
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import AdminSettingForm from "./AdminSetting/AdminSettingForm";
import AdminSettingQRCode from "./AdminSetting/AdminSettingQRCode";

export default {
	name: "AdminSetting",

	components: { Table, AdminSettingForm, AdminSettingQRCode },

	data: function() {
		return {
			search: "",

			loading: true,
			list: [],
			page: 0,
            per_page: 25,
			total: 0,

			headers: {
				id: "#",
				name: "Configuração",
				created_at: "Cadastro"
			},

			modifiers: {
				created_at: function(s) {
					return (new Date(s)).toLocaleString();
				}
			},

			current: false,
			showForm: false,
			showQRCode: false
		};
	},

	mounted: function() {
		this.load();
	},
	
	methods: {
		load: async function(is_search) {
			let form = {};

			if (this.search) {
				form.search = this.search;
			}

			if (is_search) {
				this.page = 0;
			}

			form.page = this.page;

			this.list = [];
            let response = null;
			
            this.loading = true;
            try {
                response = await Api.post_admin("setting/list", form);
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista.");
				this.loading = false;
                return;
            }
            this.loading = false;
            
            if (response.error) {
                this.$notification.error(response.data);
                return;
            }

            this.list = response.data;
            this.total = response.total;
		},

		remove: async function(id) {
			let confirm;

			confirm = await this.$alert.confirm("Você tem certeza que deseja excluir essa configuração?");
			if (!confirm) return;
            
            let response = null;

			this.loading = true;
            try {
                response = await Api.post_admin("setting/delete", {id: id});
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível excluir esta configuração.");
                return;
            }
			this.loading = false;

			if (response.error) {
				this.$notification.error(response.data);
				return;
			}

			this.$notification.success(response.data);

			this.load();
		},

		verifyStatusLogin: async function(item) {
			let form = {};

			JSON.parse(item.value).forEach(element => {
				if(element.name == "login_request_id") {
					form.id = item.id;
					form.login_request_id = element.value;
				}
			});

			if (!form.login_request_id) {
				this.$notification.error("Não foi possível obter o id da requisição.");
                return;
			}
			
            let response = null;
            try {
                response = await Api.post_admin("setting/verify-status-login", form);
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível verificar o status da conexão.");
                return;
            }
            
            if (response.error) {
				if (response.data.includes("qr shared")) {
					this.$notification.error("Não foi constatada a leitura do QRCode.");
				} else if (response.data.includes("qr code scan timed out")) {
					this.$notification.error("O tempo de leitura do QRCode foi excedido.");
				} else {
					this.$notification.error(response.data);
				}
				return;
            }

			this.$notification.success(response.data);

			this.load();
		},

		getQRCode: async function(item) {
			this.current = item;
			this.showQRCode = true;
		},

		create: function() {
			this.current = "new";
			this.showForm = true;
		},

		edit: function(item) {
			this.current = item;
			this.showForm = true;
		},
	}
}
</script>

<style scoped>		
.admin-filter-wrapper {
	position: relative;
	float: right;
	width: 200px;
	height: 30px;
	margin-top: 15px;
	color: #999;
}

.admin-filter-wrapper > i {
	position: absolute;
	top: 7px;
	left: 7px;
}

.admin-filter-input {
	position: absolute;
	width: 100%;
	height: 30px;
	padding-left: 30px;
	border-radius: 4px;
	border: 1px solid #ccc;
}


.admin-create-btn {
	float: right;
	margin-top: 16px;
	margin-left: 15px;
	padding-left: 15px;
	padding-right: 15px;
}
</style>